<template >
  <sc-menu-navigator
      @update="tripUpdate"
      @delete="(e) => $emit('delete', e)" >
    <transition
        name="el-zoom-in-bottom"
        mode="out-in" >
<!--      <el-row-->
<!--          class="dark-header"-->
<!--          key="1"-->
<!--          v-if="$route.params.tripid == 'all'" >-->

<!--      </el-row >-->
      <div
          class="dark-header"
          key="2" style="display: flex"
          v-if="$route.params.tripid != 'all'" >
        <div   style="flex-grow:1;display: flex;align-items: center;height: 100%;padding-top: 10px">

            <el-button
                style="font-weight: bold; float: left"
                @click="routeGo({ params: { tripid: 'all' } })"
                type="text"
                icon="el-icon-circle-close" ></el-button >
            <el-popover
                placement="bottom"
                v-if="ScheduleTrip"
                width="200"
                trigger="hover" >
              <div >
              <p
                  style="font-size: 10px"
                  v-for="(px,w) in ScheduleTrip.paxData"
                  :key="w" >{{ w }}:{{ px }}</p >
              </div >
            <span
                slot="reference"
                style="font-weight: bold; float: left;font-size: 14px" >{{ScheduleTrip.tripName}} on {{ ScheduleTrip.humandate }}</span >
            </el-popover >
            <span v-else >New scheduled trip</span >


        </div >
        <div   >
          <el-menu
              :default-active="$route.name"
              mode="horizontal" >
            <el-menu-item
                xindex="customer/all"
                v-if="$route.params.kind == 'package'"
                @click="routeGo({ name: 'customers', params: { tripid: 'all' } })" >
              <s-label
                  icon="dashboard"
                  text="Dashoboard" ></s-label >
            </el-menu-item >
            <el-menu-item
                index="customers"
                v-if="$route.params.kind == 'package'"
                @click="routeGo({ name: 'customers' })" >
              <s-label
                  icon="supervisor_account"
                  text="Customers" ></s-label >
            </el-menu-item >

            <transition name="el-zoom-in-center" >
              <el-menu-item
                  title="add new customers"
                  index="customers"
                  @click="
                  routeGo({ name: 'customer', params: { customerid: 'new' } })
                "
                  v-if="
                  $route.params.kind == 'package' && $route.name == 'customers'
                " >
                <el-button type="text" >
                  <fa
                      icon="plus"
                      fixed-width ></fa >
                  <fa
                      icon="users"
                      fixed-width
                      size="lg" ></fa >
                </el-button >
                <!-- <i class="material-icons">add</i> -->
              </el-menu-item >
            </transition >
            <el-menu-item
                class="nav-button"
                index="tripBookings"
                :disabled="$route.params.tripid=='new'"
                @click="
                routeGo({
                  name: 'tripBookingsBooking',
                  params: { bookingid: 'new' },
                })
              "
                v-if="$route.params.kind != 'package'" >
              <i class="material-icons" >add</i >
            </el-menu-item >
            <el-menu-item
                index="tripBookings"
                :disabled="$route.params.tripid=='new'"
                @click="
                routeGo({
                  name: 'tripBookings',
                  query: { selected_customer: null, selected_route: null },
                  params:{tripid:$route.params.tripid}
                })
              "
                v-if="$route.params.kind != 'package'" >
              <s-label
                  icon="supervisor_account"
                  text="Bookings" ></s-label >
            </el-menu-item >
            <el-menu-item
                v-if="$route.params.kind == 'package'"
                :disabled="$route.params.tripid=='new'"
                index="tripACCtransactions"
                @click="
                routeGo({
                  name: 'tripACCtransactions',
                  query: { selected_customer: null, selected_route: null },
                })
              " >
              <s-label
                  icon="shopping_cart"
                  text="Accounting" ></s-label >
            </el-menu-item >
            <el-menu-item
                v-else-if="$route.params.kind == 'excrs'"
                index="expenses"
                :disabled="$route.params.tripid=='new'"
                @click="
                routeGo({
                  name: 'expenses',
                  query: { selected_customer: null, selected_route: null },
                })
              " >
              <s-label
                  icon="shopping_cart"
                  text="Expenses" ></s-label >
            </el-menu-item >
            <el-menu-item
                v-else
                index="expenses"
                :disabled="$route.params.tripid=='new'"
                @click="
                routeGo({
                  name: 'tripcosts',
                  query: { selected_customer: null, selected_route: null },
                })
              " >
              <s-label
                  icon="shopping_cart"
                  text="Pricing" ></s-label >
            </el-menu-item >
            <!-- tripACCtransactions -->
            <!-- <el-menu-item index="setup">Setup</el-menu-item> -->
            <el-menu-item
                v-if="$route.params.kind == 'package'"
                index="package_services"
                :disabled="$route.params.tripid=='new'"
                @click="
                routeGo({
                  name: 'package_services',
                  query: { selected_customer: null, selected_route: null },
                })
              " >
              <s-label
                  icon="local_dining"
                  text="Servises" ></s-label >
            </el-menu-item >
            <el-menu-item
                index="configureScheduledTrip"

                @click="
                routeGo({
                  name: 'configureScheduledTrip',
                  query: { selected_customer: null, selected_route: null },
                })
              " >
              <s-label
                  icon="build"
                  text="Setup" ></s-label >
              <!-- <i class="material-icons">build</i> -->
            </el-menu-item >
            <!-- <el-menu-item index="expenses">Expenses</el-menu-item> -->
          </el-menu >
        </div >
      </div >
    </transition >
  </sc-menu-navigator >
</template >

<script >
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import {mapGetters, mapActions} from "vuex";
import {async} from "q";

export default {
  mixins: [commons],
  data() {
    return {
      search: null,
    };
  },
  computed: {
    navpath() {
      _log_("is..R..", this.$route);
      return this.$route.path == "/excursion" ? "/bookings" : this.$route.path;
    },
  },
  methods: {
    async tripUpdate(payload) {
      _log_("is..update..", payload);
      //planned_package_id
      if (payload.planned_package_id && payload.planned_package_id != "normal")
        payload = await api.fetchObject("scheduletrip", {
          id: payload.planned_package_id,
        });
      _log_("is..got..", payload);
      this.$emit("update", payload);
    },
  },
  watch: {
    // "$route.params.tripid": {
    //   async handler(val, oldval) {
    //   },
    //   immediate: true
    // }
  },
  async mounted() {
    _log_("is..R..", this.$route);
  },
};
</script >
